import React from 'react';
import { Redirect } from 'react-router-dom';
import { ROUTE_ACTIONS } from './constants';

export const getRedirectForAction = ({
  action,
  code,
  isAuthenticated = true,
}) => {
  if (!action) return null;

  switch (action.toLowerCase()) {
    case ROUTE_ACTIONS.PAYMENT:
      return isAuthenticated ? (
        <Redirect to={code ? `/payments/${code}` : '/payments'} />
      ) : (
        <Redirect to="/public/payment/access" />
      );
    case ROUTE_ACTIONS.CONSULTATION:
      return isAuthenticated ? (
        <Redirect
          to={
            code
              ? `/discussions?name=${encodeURIComponent(code)}`
              : '/discussions'
          }
        />
      ) : (
        <Redirect to="/hello" />
      );
    default:
      return null;
  }
};

export const getFallbackRedirect = () => <Redirect to="/home" />;
